// Configuration des blocs et séries — ordre identique à Pokécardex
// Pour ajouter un nouveau bloc : ajouter en tête de BLOC_ORDER
// Pour ajouter un set dans un bloc : ajouter son ID en tête de setIds
// Les IDs correspondent aux set IDs de TCGdex (ex: "sv1", "swsh12")
//
// `serieIds` = séries TCGdex rattachées au bloc. Tout set de ces séries qui
// n'est PAS listé dans `setIds` apparaît automatiquement en tête du bloc (les
// plus récents d'abord) au lieu de tomber dans "Autre" : c'est ce qui fait
// qu'un set qui vient de sortir se voit tout de suite après un rafraîchissement,
// sans avoir à toucher ce fichier. Le lister dans `setIds` sert alors juste à
// figer sa position exacte.

export const BLOC_ORDER = [
  // ── Pour ajouter un nouveau bloc : ajoutez-le ICI en tête ──
  // ── Pour ajouter un set dans un bloc : ajoutez son ID en tête de setIds ──
  {
    key: "me", label: "Méga-Évolution",
    serieIds: ["me"],
    setIds: [
      // ⚠️ Un set de la série "me" ABSENT de cette liste remonte automatiquement
      // en tête du bloc (règle des nouveautés) : me05 n'y était pas et passait
      // donc AU-DESSUS de 30th, sorti après lui (signalé le 2026-09-20).
      "30th",   // 30ᵉ Anniversaire (ME5.5, 2026-09-16) — sa Collection Classique "30th-c" est fondue dedans
      "me05",   // Nuit Noire
      "me04",   // Chaos Ascendant
      "me03",   // Équilibre Parfait
      "me02.5", // Héros Transcendants
      "me02",   // Flammes Fantasmagoriques
      "me01",   // Méga-Évolution
      "mee",    // Énergies Méga-Évolution
      "mep",    // Promos Méga-Évolution
    ],
  },
  {
    key: "sv", label: "Écarlate et Violet",
    serieIds: ["sv"],
    setIds: [
      "sv10.5b", // Foudre Noire
      "sv10.5w", // Flamme Blanche
      "sv10",    // Rivalités Destinées
      "sv09",    // Aventures Ensemble
      "sv08.5",  // Évolutions Prismatiques
      "sv08",    // Étincelles Déferlantes
      "sv07",    // Couronne Stellaire
      "sv06.5",  // Fable Nébuleuse
      "sv06",    // Mascarade Crépusculaire
      "sv05",    // Forces Temporelles
      "sv04.5",  // Destinées de Paldea
      "sv04",    // Faille Paradoxe
      "sv03.5",  // 151
      "sv03",    // Flammes Obsidiennes
      "sv02",    // Évolutions à Paldea
      "sv01",    // Écarlate et Violet
      "sve",     // Énergies Écarlate et Violet
      "svp",     // Promos SVP
    ],
  },
  {
    key: "swsh", label: "Épée et Bouclier",
    serieIds: ["swsh"],
    setIds: [
      "swsh12.5",  // Zénith Suprême
      "swsh12",    // Tempête Argentée
      "swsh11",    // Origine Perdue
      "swsh10.5",  // Pokémon GO
      "swsh10",    // Astres Radieux
      "swsh9",     // Stars Étincelantes
      "swsh8",     // Poing de Fusion
      "cel25",     // Célébrations
      "cel25cc",   // Célébrations Collection Classique
      "swsh7",     // Évolution Céleste
      "swsh6",     // Règne de Glace
      "swsh5",     // Styles de Combat
      "swsh4.5",   // Destinées Radieuses
      "swsh4.5sv", // Destinées Radieuses Coffre Étincelant
      "swsh4",     // Voltage Éclatant
      "swsh3.5",   // La Voie du Maître
      "swsh3",     // Ténèbres Embrasées
      "swsh2",     // Clash des Rebelles
      "swsh1",     // Épée et Bouclier
      "swshp",     // Promos Épée et Bouclier
    ],
  },
  {
    key: "sm", label: "Soleil et Lune",
    serieIds: ["sm"],
    setIds: [
      "sm12",    // Éclipse Cosmique
      "sm115",   // Destinées Occultes
      "sm11",    // Harmonie des Esprits
      "sm10",    // Alliance Infaillible
      "sm9",     // Duo de Choc
      "sm8",     // Tonnerre Perdu
      "sm7.5",   // Majesté des Dragons
      "sm7",     // Tempête Céleste
      "sm6",     // Lumière Interdite
      "sm5",     // Ultra-Prisme
      "sm4",     // Invasion Carmin
      "sm3.5",   // Légendes Brillantes
      "sm3",     // Ombres Ardentes
      "sm2",     // Gardiens Ascendants
      "sm1",     // Soleil et Lune
      "smp",     // Promos Soleil et Lune
    ],
  },
  {
    key: "xy", label: "XY",
    serieIds: ["xy"],
    setIds: [
      "xy12",  // Évolutions
      "xy11",  // Offensive Vapeur
      "xy10",  // Impact des Destins
      "g1",    // Générations
      "xy9",   // Rupture Turbo
      "xy8",   // Impulsion Turbo
      "xy7",   // Origines Antiques
      "xy6",   // Ciel Rugissant
      "dc1",   // Double Danger
      "xy5",   // Primo-Choc
      "xy4",   // Vigueur Spectrale
      "xy3",   // Poings Furieux
      "xy2",   // Étincelles
      "xy1",   // XY
      "xy0",   // Bienvenue à Kalos
      "xyp",   // Promos XY
    ],
  },
  {
    key: "bw", label: "Noir et Blanc",
    serieIds: ["bw"],
    setIds: [
      "bw11",  // Legendary Treasures
      "bw10",  // Explosion Plasma
      "bw9",   // Glaciation Plasma
      "bw8",   // Tempête Plasma
      "bw7",   // Frontières Franchies
      "dv1",   // Coffre des Dragons
      "bw6",   // Dragons Exaltés
      "bw5",   // Explorateurs Obscurs
      "bw4",   // Destinées Futures
      "bw3",   // Nobles Victoires
      "bw2",   // Pouvoirs Émergents
      "bw1",   // Noir et Blanc
      "bwp",   // Promos Noir et Blanc
    ],
  },
  {
    key: "hgss", label: "HeartGold SoulSilver",
    serieIds: ["hgss"],
    setIds: [
      "hgss4",   // Triomphant
      "hgss3",   // Indomptable
      "hgss2",   // Déchaînement
      "hgss1",   // HeartGold SoulSilver
      "hgssp",   // Promos HGSS
    ],
  },
  {
    key: "col", label: "Appel des Légendes",
    serieIds: ["col"],
    setIds: [
      "col1",    // L'Appel des Légendes
    ],
  },
  {
    key: "pl", label: "Platine",
    serieIds: ["pl"],
    setIds: [
      "pl4",   // Arceus (EN)
      "pl3",   // Vainqueurs Suprêmes
      "pl2",   // Rivaux Émergeants
      "pl1",   // Platine
    ],
  },
  {
    key: "dp", label: "Diamant et Perle",
    serieIds: ["dp"],
    setIds: [
      "dp7",   // Tempête
      "dp6",   // Éveil des Légendes
      "dp5",   // Aube Majestueuse
      "dp4",   // Duels au Sommet
      "dp3",   // Merveilles Secrètes
      "dp2",   // Trésors Mystérieux
      "dp1",   // Diamant & Perle
      "dpp",   // Promos DP
    ],
  },
  {
    key: "ex", label: "EX",
    serieIds: ["ex"],
    setIds: [
      "ex16",  // Gardiens du Pouvoir
      "ex15",  // Île des Dragons
      "ex14",  // Gardiens de Cristal
      "ex13",  // Fantômes Holon
      "ex12",  // Créateurs de Légendes
      "ex11",  // Espèces Delta
      "ex10",  // Forces Cachées
      "ex9",   // Émeraude
      "ex8",   // Deoxys
      "ex7",   // Team Rocket Returns (EN)
      "ex6",   // Rouge Feu & Vert Feuille
      "ex5",   // Légendes Oubliées
      "ex4",   // Team Magma VS Team Aqua
      "ex3",   // Dragon
      "ex2",   // Tempête de Sable
      "ex1",   // Rubis & Saphir
      "np",    // Black Star Nintendo
    ],
  },
  {
    key: "wizard", label: "Wizard",
    serieIds: ["base", "neo", "ecard", "gym", "lc"],
    setIds: [
      // Les sets marqués (EN) n'existent pas en français chez TCGdex : ils
      // arrivent par le repli anglais du backend (cf. merge_english_series).
      "ecard3",  // Skyridge (EN)
      "ecard2",  // Aquapolis
      "ecard1",  // Expedition
      "lc",      // Legendary Collection (EN)
      "neo4",    // Neo Destiny
      "neo3",    // Neo Revelation
      "neo2",    // Neo Discovery
      "neo1",    // Neo Genesis
      "gym2",    // Gym Challenge (EN)
      "gym1",    // Gym Heroes (EN)
      "base5",   // Team Rocket
      "base4",   // Set de Base 2 (EN)
      "base3",   // Fossile
      "base2",   // Jungle
      "base1",   // Set de Base
      "basep",   // Wizards Black Star Promos
    ],
  },
  // ── Blocs hors ère, relevés sur la page /series de Pokécardex ────────────
  // Ces sets ne sont PAS des extensions d'une ère : ce sont des produits à
  // part. TCGdex les range pourtant dans la série de leur époque (My First
  // Battle dans « sv », Pokémon Futsal dans « swsh »), ce qui les faisait
  // atterrir au milieu d'Écarlate et Violet ou d'Épée et Bouclier une fois la
  // page d'accueil découpée en blocs. On suit donc le classement Pokécardex,
  // qui est celui que l'utilisateur a en tête.
  // ⚠️ Volontairement SANS `serieIds` (sauf kits/McDo/POP, dont la série
  // TCGdex correspond exactement au bloc) : sinon un futur set de la série
  // « misc » viendrait se ranger tout seul dans « Jumbos ».
  {
    key: "promos", label: "Promos",
    setIds: [
      "fut2020", // Pokémon Futsal 2020 (EN)  — Pokécardex FUTSAL
      "det1",    // Détective Pikachu          — DPK
      "xya",     // Promos Alternative A Jaune — PRAL
      "ru1",     // Pokémon Rumble (EN)        — RUM
      "ex5.5",   // Poké Card Creator Pack (EN)— PCP
      "si1",     // Southern Islands (EN)      — SI
      "miscp",   // Promos non numérotées      — UPC
      "bog",     // Best of Game (EN)          — WBP
    ],
  },
  {
    key: "ligue", label: "Ligue Pokémon",
    serieIds: ["pop"],
    setIds: [
      "pop9", "pop8", "pop7", "pop6", "pop5", "pop4", "pop3", "pop2", "pop1",
    ],
  },
  {
    key: "jumbo", label: "Jumbos",
    setIds: ["jumbo"],
  },
  {
    key: "tk", label: "Kit du Dresseur",
    serieIds: ["tk"],
    setIds: [
      "mfb",          // My First Battle — Pokécardex le range ici, pas dans EV
      "tk-sm-r", "tk-sm-l",
      "tk-xy-su", "tk-xy-p", "tk-xy-latio", "tk-xy-latia",
      "tk-xy-w", "tk-xy-b", "tk-xy-n", "tk-xy-sy",
      "tk-bw-e", "tk-bw-z",
      "tk-hs-r", "tk-hs-g",
      "tk-dp-m", "tk-dp-l",
      "tk-ex-p", "tk-ex-m", "tk-ex-latio", "tk-ex-latia",
    ],
  },
  {
    key: "mc", label: "McDonald's",
    serieIds: ["mc"],
    setIds: [
      "2024sv", "2023sv", "2022swsh", "2021swsh",
      "2019sm-fr", "2019sm", "2018sm-fr", "2018sm",
      "2017sm", "2016xy", "2015xy", "2014xy", "2013bw", "2012bw", "2011bw",
    ],
  },
  {
    key: "tcgp", label: "TCG Pocket",
    serieIds: ["tcgp"],
    setIds: [
      "B2a", "B2", "B1a", "B1",
      "A4a", "A4", "A3b", "A3a", "A3", "A2b", "A2a", "A2", "A1a", "A1", "P-A",
    ],
  },
  {
    // World Championships : sets ENTIÈREMENT locaux (absents de TCGdex), les
    // seules extensions de l'appli dont les cartes sont des vraies cartes
    // d'AUTRES sets recopiées (contenu des decks distribués aux joueurs) —
    // voir le backend, LOCAL_ONLY_SETS. Seules 2 des 20 années sont saisies
    // pour l'instant (wc25, wc22) ; les suivantes s'ajouteront ici au fil de
    // l'extraction (le reste des noms/numéros par année est dans WC_PLAN.md
    // du scratchpad de session).
    key: "wc", label: "World Championships",
    serieIds: ["wc"],
    setIds: ["wc25", "wc22"],
  },
];

// Sous-sets satellites (Galerie de Dresseurs "tg", Galerie Galaroise "gg")
// qui font partie de leur set principal — jamais une entrée de navigation
// séparée. Le backend fusionne déjà leurs cartes à la fin du set principal
// (get_set), donc on les exclut ici (sidebar + page d'accueil) pour ne pas
// les lister une deuxième fois comme s'ils étaient des collections à part.
// ⚠️ 2026-09-08 : les 4 galeries TG portaient un ".5" ne correspondant à
// AUCUN id TCGdex réel (le vrai id, vérifié en direct, est "swsh12tg" et non
// "swsh12.5tg") — donc ce filtre ne les excluait jamais en pratique, elles
// remontaient comme des collections à part dans "Épée et Bouclier". Corrigé
// aux vrais ids ; "swsh12.5gg" était déjà correct.
export const SATELLITE_SET_IDS = new Set([
  "swsh9tg", "swsh10tg", "swsh11tg", "swsh12tg", "swsh12.5gg",
  // Sous-collections rattachées à leur set principal côté backend :
  "exu",       // Collection Zarbi -> EX Forces Cachées
  "sma",       // Coffre Étincelant (Destinées Occultes) -> Destinées Occultes
  "rc",        // Radiant Collection -> Trésors Légendaires (aucune carte chez TCGdex)
  "swsh4.5sv", // Coffre Étincelant (Destinées Radieuses) -> Destinées Radieuses
  "cel25cc",   // Célébrations Collection Classique -> Célébrations
  "30th-c",    // Collection Classique 30ᵉ Anniversaire -> 30ᵉ Anniversaire
]);

// Set IDs connus — tout le reste va dans "Autre"
export const KNOWN_SET_IDS = new Set(BLOC_ORDER.flatMap(b => b.setIds));
// Serie IDs couverts (pour filtrer "Autre")
export const KNOWN_SERIE_IDS = new Set(["sv","swsh","sm","xy","bw","hgss","col","pl","dp","ex","neo","ecard","base","gym","lc","me","pop","tk","tcgp","mc","wc","misc"]);
